import ApiClient from './ApiClient';

class OrderIssueTagsAPI extends ApiClient {
  constructor() {
    super('order_issue_tags', { accountScoped: true });
  }

  // Get all tags and combinations
  getAll() {
    return axios.get(this.url);
  }

  // Create a new tag
  create(data) {
    return axios.post(this.url, { order_issue_tag: data });
  }

  // Update a tag
  update(tagId, data) {
    return axios.patch(`${this.url}/${tagId}`, { order_issue_tag: data });
  }

  // Delete a tag
  delete(tagId) {
    return axios.delete(`${this.url}/${tagId}`);
  }

  // Toggle protected status
  toggleProtected(tagId) {
    return axios.post(`${this.url}/${tagId}/toggle_protected`);
  }

  // Update combination (link/unlink tags)
  updateCombination(problemTagId, actionTagId, linked) {
    return axios.post(`${this.url}/update_combination`, {
      problem_tag_id: problemTagId,
      action_tag_id: actionTagId,
      linked
    });
  }

  // Sync tags from canned response templates
  syncFromTemplates() {
    return axios.post(`${this.url}/sync_from_templates`);
  }

  // Seed default quality tags (Product Quality + related action tags)
  seedQualityDefaults() {
    return axios.post(`${this.url}/seed_quality_defaults`);
  }
}

export default new OrderIssueTagsAPI();
